import React, { useState } from 'react';
import { Row, Col, Spin, Button, Space } from 'antd';
import { DownloadOutlined, UnlockOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { startGetOpXls } from '../../context/actions/ordenesPagoActions';
import { ModalSolicitaLiberar } from '../ordenesPago/busca/_ModalSolicitaLiberar';
import { usePagosV2Page } from './usePagosV2';
import './pagosV2.css';

import FiltrosPagosV2 from './features/Filtros/FiltrosPagosV2';
import AccionesPagosV2 from './features/Acciones/AccionesPagosV2';
import TablaPagos from './features/TablaPagos/TablaPagos';
import ModalCrearOrdenPago from './features/CrearOrdenPago/ModalCrearOrdenPago';
import ModalCargaMasivaPDFs from './features/CargaMasiva/ModalCargaMasivaPDFs';
import ModalCargaMasivaXLSX from './features/CargaMasiva/ModalCargaMasivaXLSX';
import ModalEnviarEmail from './features/OrdenPagoDetalle/modales/ModalEnviarEmail';
import ModalCargarFactura from './features/OrdenPagoDetalle/modales/ModalCargarFactura';
import ModalCargaConcesionados from './features/OrdenPagoDetalle/modales/ModalCargaConcesionados';

export default function PagosV2() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [modalLiberarOpen, setModalLiberarOpen] = useState(false);
  const {
    busquedaProps,
    tablaProps,
    accionesProps,
    modalBusquedaVisible,
    setModalBusquedaVisible,
    loadingPagos2,
    estatusSeleccionado,
    setEstatusSeleccionado,
    estatusOptions,
    modalCargaMasivaVisible,
    setModalCargaMasivaVisible,
    modalCargaMasivaXLSXVisible,
    setModalCargaMasivaXLSXVisible,
    handleCargaMasivaSuccess,
    handleDescargarOpXls,
    handleDescargarXlsComplementosPago,
    handleAutorizarMasivo,
    modalEmailVisible,
    setModalEmailVisible,
    emails,
    setEmails,
    loadingEmail,
    handleEnviarEmail,
    ordenPagoSeleccionada,
    modalPagoDirectoVisible,
    setModalPagoDirectoVisible,
    loadingPagoDirecto,
    setLoadingPagoDirecto,
    handlePagoDirectoSuccess,
    handlePagoDirectoCancel,
    asistenciasSeleccionadas,
    modalConcesionadosVisible,
    setModalConcesionadosVisible,
    loadingConcesionados,
    setLoadingConcesionados,
    handleConcesionadosSuccess,
    handleConcesionadosCancel
  } = usePagosV2Page();

  return (
    <div className="pagos-v2 pagos-v2__container">
      <div className="card__titulo" style={{ marginBottom: 16 }}>Pagos V2</div>

      <Row align="middle" justify="space-between" style={{ marginBottom: 20 }}>
        <Col>
          <FiltrosPagosV2
            estatusSeleccionado={estatusSeleccionado}
            setEstatusSeleccionado={setEstatusSeleccionado}
            estatusOptions={estatusOptions}
            onCargaMasivaPDF={() => setModalCargaMasivaVisible(true)}
            onCargaMasivaXLSX={() => setModalCargaMasivaXLSXVisible(true)}
            onDescargarXLS={handleDescargarOpXls}
            onDescargarXlsComplementosPago={handleDescargarXlsComplementosPago}
            onAutorizarMasivo={handleAutorizarMasivo}
          />
        </Col>
        {!estatusSeleccionado && (
          <Col>
            <Space size="middle">
              <Button
                icon={<UnlockOutlined />}
                onClick={() => setModalLiberarOpen(true)}
              >
                Solicitar Liberar Asistencias
              </Button>
              <Button
                icon={<DownloadOutlined />}
                onClick={() => dispatch(startGetOpXls())}
              >
                Descargar XLS OPs Activas
              </Button>
              <Button
                icon={<ClockCircleOutlined />}
                onClick={() => history.push('/ordenesPagoV2/serviciosPendientes')}
              >
                Servicios Pendientes
              </Button>
            </Space>
          </Col>
        )}
        <Col>
          <AccionesPagosV2
            onCrearOrdenPago={() => setModalBusquedaVisible(true)}
            accionesProps={accionesProps}
          />
        </Col>
      </Row>

      {!estatusSeleccionado ? (
        <div className="pagos-v2__empty-state">
          Selecciona un estatus para ver las órdenes de pago
        </div>
      ) : loadingPagos2 ? (
        <div className="pagos-v2__loading-state">
          <Spin size="large" />
        </div>
      ) : (
        <TablaPagos {...tablaProps} />
      )}

      <ModalCrearOrdenPago
        visible={modalBusquedaVisible}
        onClose={() => setModalBusquedaVisible(false)}
        {...busquedaProps}
      />

      <ModalCargaMasivaPDFs
        visible={modalCargaMasivaVisible}
        onClose={() => setModalCargaMasivaVisible(false)}
        onSuccess={handleCargaMasivaSuccess}
      />

      <ModalCargaMasivaXLSX
        visible={modalCargaMasivaXLSXVisible}
        onClose={() => setModalCargaMasivaXLSXVisible(false)}
        onSuccess={handleCargaMasivaSuccess}
      />

      <ModalEnviarEmail
        visible={modalEmailVisible}
        onClose={() => setModalEmailVisible(false)}
        emails={emails}
        setEmails={setEmails}
        onEnviar={handleEnviarEmail}
        loading={loadingEmail}
        proveedorEmail={ordenPagoSeleccionada?.proveedorEmail || ''}
      />

      <ModalCargarFactura
        showModal={modalPagoDirectoVisible}
        setShowModal={setModalPagoDirectoVisible}
        ordenPagoID={null}
        loading={loadingPagoDirecto}
        setLoading={setLoadingPagoDirecto}
        onSuccess={handlePagoDirectoSuccess}
        onCancel={handlePagoDirectoCancel}
        esPagoDirecto={true}
        asistencias={asistenciasSeleccionadas}
      />

      <ModalCargaConcesionados
        visible={modalConcesionadosVisible}
        onClose={handleConcesionadosCancel}
        asistencias={asistenciasSeleccionadas}
        loading={loadingConcesionados}
        setLoading={setLoadingConcesionados}
        onSuccess={handleConcesionadosSuccess}
      />

      <ModalSolicitaLiberar open={modalLiberarOpen} setOpen={setModalLiberarOpen} />
    </div>
  );
}
